import { ACTION_PANEL_STATE_KEY } from "../../selectors";

export const LAYER_MODULE_STATE_KEY = "LAYER_MODULE_STATE";

export const getModuleState = (state) => state[ACTION_PANEL_STATE_KEY][LAYER_MODULE_STATE_KEY];
